import { gql } from '@grandvisionhq/graphql';

const storeDistance = gql`
  fragment StoreDistance on Store {
    distance @include(if: $withDistance)
    timeByCar @include(if: $withTimeByCar)
    timeByFoot @include(if: $withTimeByFoot)
  }
`;
const GET_STORE_DISTANCE = gql`
  query GetStoreDistance(
    $globalStoreId: ID
    $deviceGeoLocation: GeoLocationInput!
    $withDistance: Boolean = false
    $withTimeByCar: Boolean = false
    $withTimeByFoot: Boolean = false
  ) {
    store(globalStoreId: $globalStoreId, deviceGeoLocation: $deviceGeoLocation) {
      ...StoreDistance
    }
  }
  ${storeDistance}
`;

export { GET_STORE_DISTANCE };
//# sourceMappingURL=queries.js.map
